module.exports = __webpack_public_path__ + "static/biggest-reimbursement-a22309499239e0763cdbf9deb7d7744f.svg";